import ClipSelectTranscriptEditor from './ClipSelectTranscriptEditor';

export default ClipSelectTranscriptEditor;
